import { forwardRef } from "react";
import { ShoppingCartOutlined } from "ui";
import { useAppSelector } from "../../hooks/ReduxHooks";
import { UIBadge, UIIconButton } from "ui";


export const NavCartButton = forwardRef((_props, _ref) => {
  const { activeCartData } = useAppSelector((state) => state.activeCart);

  return (
    <UIIconButton aria-label="cart" className="cremaNavbar__cartButton">
      <UIBadge count={activeCartData?.cart_lines?.length || 0}>
        <ShoppingCartOutlined />
      </UIBadge>
    </UIIconButton>
  );
});

export default NavCartButton
